import { createSvgIcon } from "@mui/material";

export const BlocksIcon = createSvgIcon(
  <svg
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12550_31869)">
      <path
        d="M38.339 25.0945H27.9585C25.3886 25.0945 23.2974 23.0033 23.2974 20.4334V4.66113C23.2974 2.09121 25.3886 0.00839844 27.9585 0H38.339C40.9089 0 43.0001 2.09121 43.0001 4.66113V20.4418C43.0001 23.0117 40.9089 25.0945 38.339 25.0945ZM27.9585 1.14219C26.0185 1.14219 24.4396 2.7127 24.4396 4.65273V20.4334C24.4396 22.3734 26.0185 23.9439 27.9585 23.9523H38.339C40.279 23.9523 41.8495 22.3818 41.8579 20.4334V4.66113C41.8579 2.72109 40.2874 1.15059 38.339 1.15059L27.9585 1.14219Z"
        fill="#2CAF2C"
      />
      <path
        d="M15.0416 43H4.66113C2.09121 43 0 40.9088 0 38.3389V4.66113C0 2.09121 2.08281 0 4.66113 0H15.0416C17.6115 0 19.7027 2.09121 19.7027 4.66113V38.3389C19.7027 40.9088 17.6115 43 15.0416 43ZM4.66113 1.14219C2.72109 1.14219 1.15059 2.7127 1.15059 4.65273V38.3305C1.15059 40.2705 2.72109 41.841 4.66113 41.8494H15.0416C16.9816 41.8494 18.5605 40.2789 18.5605 38.3389V4.66113C18.5605 2.72109 16.9816 1.14219 15.0416 1.14219H4.66113Z"
        fill="#2CAF2C"
      />
      <path
        d="M38.339 42.9999H27.9585C25.3886 42.9999 23.2974 40.9087 23.2974 38.3388V33.3501C23.2974 30.7802 25.3886 28.6974 27.9585 28.689H38.339C40.9089 28.689 42.9917 30.7802 43.0001 33.3501V38.3388C43.0001 40.9087 40.9089 42.9999 38.339 42.9999ZM27.9585 29.8395C26.0185 29.8395 24.4396 31.4101 24.4396 33.3585V38.3472C24.4396 40.2872 26.0185 41.8577 27.9585 41.8661H38.3474C40.2874 41.8661 41.8579 40.2956 41.8663 38.3472V33.3585C41.8663 31.4185 40.2958 29.8479 38.3474 29.8395H27.9585Z"
        fill="#2CAF2C"
      />
    </g>
    <defs>
      <clipPath id="clip0_12550_31869">
        <rect width="43" height="43" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "Blocks Icon"
);
